import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import simpleApi from 'app/services/simpleApi'
import requests from 'app/requests/Order/OrderBilling.requests'

type RequestParams = {
    orderNumber: string,
    data: {id: number},
}

const useRelinkLaneFee = (onSuccess: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRelinkLaneFee,
        onError,
    } = useHandleStatusRequest({
        id: 'relinkLaneFee',
        title: 'Relink Lane Fee',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updateLaneFees({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessRelinkLaneFee,
        onError,
    })
}

export default useRelinkLaneFee
